import { render, staticRenderFns } from "./CuentasCobrar.vue?vue&type=template&id=9b0b6410&"
import script from "./CuentasCobrar.vue?vue&type=script&lang=js&"
export * from "./CuentasCobrar.vue?vue&type=script&lang=js&"
import style0 from "./CuentasCobrar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports